export const scenariosQueryKeys = {
  all: ["orchestratorScenarios"] as const,
  lists: () => [...scenariosQueryKeys.all, "list"] as const,
  list: (propertyTicker: string) => [...scenariosQueryKeys.lists(), { propertyTicker }] as const,
  details: () => [...scenariosQueryKeys.all, "detail"] as const,
  detail: (propertyTicker: string, id: string) =>
    [...scenariosQueryKeys.details(), propertyTicker, id] as const,
};
